import React from 'react';
import PropTypes from 'prop-types';

import {
    LatestBlogPosts,
    LayoutRow,
    LayoutRowColumn,
} from '@ratehub/web-components';

import BLOCK_MAP from '../definitions/TemplateCorporateBlockMap';
import createBlogHeroBlocks from '../functions/createBlogHeroBlocks';
import MenuTopicsPropType from '../definitions/MenuTopicsPropType';
import Layout from './Layout';


function BlogCategoryPage({
    posts,
    category,
    hasMorePages,
    blogTopics,
}) {
    const CONTENT = createBlogHeroBlocks(category.name);

    return (
        <Layout
            blocks={CONTENT}
            blockMap={BLOCK_MAP}
            blogTopics={blogTopics}
        >
            <LayoutRow
                className="rh-layout-default rh-pt-0 rh-pb-4"
                includeContentPadding={false}
            >
                <LayoutRowColumn>
                    <LatestBlogPosts
                        initialPosts={posts}
                        categories={category.id}
                        hasMorePages={hasMorePages}
                    />
                </LayoutRowColumn>
            </LayoutRow>
        </Layout>
    );
}

BlogCategoryPage.propTypes = {
    posts: PropTypes.array.isRequired,
    category: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    }).isRequired,
    hasMorePages: PropTypes.bool.isRequired,
    blogTopics: MenuTopicsPropType.isRequired,
};

export default BlogCategoryPage;
